<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :close-on-click-modal="false" class="radish-dia">
    <div class="radish-dia-body" style="padding: 15px 0">
      <kpiMappingTable v-if="type === 'Mapping'" :table="table"></kpiMappingTable>
      <kpiProjectTable v-else-if="type === 'project'" :type="subType" :table="table"></kpiProjectTable>
      <kpiCompanyTable v-else-if="type === 'company'" :table="table"></kpiCompanyTable>
      <kpiListTable v-else-if="type === 'file'" :table="table"></kpiListTable>
      <table v-else class="a-table" cellspacing="0" style="width:100%">
        <tr>
          <template v-for="head in heads">
            <th :key="head.label + 'h'">{{ head.label }}</th>
          </template>
        </tr>
        <tr v-for="(item, index) in table" :key="'item' + index">
          <td v-for="head in heads" :key="head.label + 'b'" @click="head.onClick(item)">
            <span v-if="head.onClick" class="radish-btn radish-btn-text">{{ item[head.prop] }}</span>
            <span v-else>{{ item[head.prop] }}</span>
          </td>
        </tr>
      </table>
    </div>
  </el-dialog>
</template>
<script>
import { kpiListTable, kpiCompanyTable, kpiMappingTable, kpiProjectTable } from '../../company'

export default {
  components: { kpiListTable, kpiCompanyTable, kpiMappingTable, kpiProjectTable },
  data() {
    return {
      dialogVisible: false,
      title: '',
      table: [],
      heads: [],
      type: '',
      subType: ''
    }
  },
  methods: {
    open(params) {
      const { table, heads, type, title, subType } = params
      this.table = table
      this.heads = heads
      this.type = type
      this.title = title
      this.subType = subType
      this.dialogVisible = true
    },
  },
}
</script>
<style scoped></style>
